/**
 * Collapsed preview functions for each block type.
 *
 * Extracted into a dedicated module so that block components can be
 * lazy-loaded (React.lazy / dynamic import) without Vite pulling the
 * full component code into the main bundle via the static preview import.
 *
 * Each function: (data) => string | null
 */

export function quickPollPreview(data) {
  return data?.question?.text || null;
}

export function announcementsPreview(data) {
  const html = data?.html_content;
  if (!html) return null;

  // Strip HTML tags and decode entities
  const text = html
    .replace(/<[^>]*>/g, ' ') // Remove HTML tags
    .replace(/&nbsp;/g, ' ') // Decode common entities
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/\s+/g, ' ') // Normalize whitespace
    .trim();

  if (!text) return null;

  // Truncate to ~60 chars at word boundary
  if (text.length <= 60) return text;
  const truncated = text.slice(0, 60).replace(/\s+\S*$/, '');
  return truncated + '\u2026';
}

export function smartBlockPreview(data) {
  if (!data) return null;

  // For steps 1-2, show the question (API returns { question: { text, options } })
  if (data.question?.text) {
    return data.question.text;
  }

  // For step 3 with offers, show a teaser
  if (data.offers && data.offers.length > 0) {
    return `${data.offers.length} personalized recommendation${data.offers.length > 1 ? 's' : ''} for you`;
  }

  return null;
}
